module.exports = __webpack_public_path__ + "img/facebook_icon.347f35ed.svg";